export default __webpack_public_path__ + "static/media/YAS0340.34I-29791_-17228_0.6f681504.jpg";